import { render, staticRenderFns } from "./homeDown.vue?vue&type=template&id=b20950c8&scoped=true&"
import script from "./homeDown.vue?vue&type=script&lang=js&"
export * from "./homeDown.vue?vue&type=script&lang=js&"
import style0 from "./homeDown.vue?vue&type=style&index=0&id=b20950c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20950c8",
  null
  
)

export default component.exports